var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.395,
    height: 7.046,
    viewBox: "0 0 12.395 7.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Down",
    "data-name": "Component 117 \\u2013 3",
    transform: "translate(0.424 0.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38327",
    "data-name": "Path 38327",
    d: "M18,7.5l5.773,5.773L18,19.046",
    transform: "translate(19.046 -18) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDown);
export default __webpack_public_path__ + "static/media/dropdown-down.7a0598a5c589554ae71aa03f80a120bd.svg";
export { ForwardRef as ReactComponent };